export default {
  sections: {
    settings: 'Configuración',
  },
  status_switch: {
    label: 'Programa de fidelización',
    on: 'Activado',
    off: 'Desactivado',
    description: 'Los clientes ganan reembolso en cada pedido y pueden canjearlo al pagar.',
    description_missing: 'Guarda la configuración de abajo para iniciar tu programa de fidelización.',
  },
  alerts: {
    off: 'Tu programa de fidelización está desactivado. Los clientes no ganan reembolso en pedidos nuevos, no pueden canjear sus puntos y no ven el programa en tu tienda. Los puntos ya acumulados se conservan y caducan como de costumbre.',
    expired: 'Tu programa de fidelización ha finalizado. Actívalo para reiniciarlo sin fecha de fin.',
  },
  form: {
    title: {
      label: 'Título',
    },
    percentage: {
      label: 'Porcentaje de cashback',
      validation: {
        required: 'El porcentaje de cashback es obligatorio',
        min: 'El valor mínimo del porcentaje de cashback es {{value}}%',
        max: 'El valor máximo del porcentaje de cashback es {{value}}%',
      },
    },
    point_lifetime: {
      label: '¿Cuántos días desea dar a sus clientes para usar los puntos?',
      validation: {
        min: 'Mínimo {{value}} días para la expiración de puntos',
      },
    },
    min_spending_limit: {
      label: 'Límite de gasto mínimo para cashback',
      validation: {
        required: 'El límite de gasto mínimo es obligatorio',
        gt_zero: 'El límite de gasto mínimo debe ser mayor que 0',
        lt_max_spending_limit: 'El límite de gasto mínimo debe ser menor que el límite de gasto máximo',
      },
    },
    max_spending_limit: {
      label: 'Límite de gasto máximo para cashback',
      validation: {
        required: 'El límite de gasto máximo es obligatorio',
        gt_min_spending_limit: 'El límite de gasto máximo debe ser mayor que el límite de gasto mínimo',
      },
    },
    has_welcome_bonus: {
      label: 'Bono de bienvenida',
      description: 'Ofrezca a sus nuevos clientes un bono de cashback al registrarse',
    },
    welcome_bonus: {
      label: 'Valor del bono de bienvenida',
    },
    has_end_date: {
      label: 'Duración',
      options: {
        false: 'Indefinido',
        true: 'Con fecha de fin específica',
      },
    },
    end_date: {
      label: 'Fecha de fin',
    },
    has_mobile_app_signup_bonus: {
      label: 'Bono de registro en la app móvil',
      description: 'Recompense a los usuarios que inicien sesión por primera vez en la app móvil',
    },
    mobile_app_signup_bonus: {
      label: 'Importe del bono',
    },
  },
  tags: {
    inactive: 'No activo',
    active: 'Activo',
    expired: 'Expirado',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: 'Los cambios se han guardado',
    failed_to_save_changes: 'Error al guardar los cambios',
    turned_on: 'Programa de fidelización activado',
    turned_off: 'Programa de fidelización desactivado',
  },
};
